import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['sentinel', 'spinner', 'nextPage']
  static values = { contained: { type: Boolean, default: false } }

  connect() {
    this.observer = new IntersectionObserver(
      (entries) => this.#onIntersect(entries),
      {
        root: this.containedValue ? this.element : null,
        rootMargin: '200px',
      }
    )
    this.#observeSentinel()
  }

  disconnect() {
    this.observer?.disconnect()
  }

  nextPageTargetConnected() {
    if (this.observer) {
      this.#hideSpinner()
      this.#observeSentinel()
    }
  }

  nextPageTargetDisconnected() {
    this.observer?.disconnect()
    this.#hideSpinner()
  }

  #observeSentinel() {
    if (this.hasSentinelTarget) {
      this.observer.observe(this.sentinelTarget)
    }
  }

  #onIntersect(entries) {
    const entry = entries[0]
    if (!entry.isIntersecting) return
    if (!this.hasNextPageTarget) return

    const url = this.nextPageTarget.dataset.url
    if (!url) return

    this.observer.disconnect()
    this.#showSpinner()
    this.#fetchNextPage(url)
  }

  #showSpinner() {
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.remove('d-none')
    }
  }

  #hideSpinner() {
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.add('d-none')
    }
  }

  #fetchNextPage(url) {
    const parsedUrl = new URL(url, window.location.origin)
    if (parsedUrl.origin !== window.location.origin) return

    fetch(parsedUrl.toString(), {
      headers: { Accept: 'text/vnd.turbo-stream.html' },
      credentials: 'same-origin',
    })
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        return response.text()
      })
      .then((html) => Turbo.renderStreamMessage(html))
      .catch(() => this.#hideSpinner())
  }
}
